import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import { useParams } from "react-router-dom";
import type { ICSVUpload } from "../../../hooks/http/admin/favorites/add-new-csv-favorite-collection.admin.http";
import { useCsvRetryAllAdminHttp } from "../../../hooks/http/admin/favorites/csv-retry-all.admin.http";

type AppProps = {
	csv: ICSVUpload;
	className?: string;
};

export const RetryAll: FunctionComponent<AppProps> = ({ csv, className }) => {
	const { favoriteId } = useParams();

	const { execute: retryAllHttp, fetching: fetchingRetryAll } =
		useCsvRetryAllAdminHttp();

	const { toast } = useToast();

	async function retryFailed() {
		if (!favoriteId) {
			return;
		}

		const response = await retryAllHttp({
			pathParams: { id: csv.id },
			body: null,
		});

		if (!response.success) {
			return handleHttpError(response, toast);
		}

		toast({
			toastType: "success",
			content: `${csv.successCount} successful uploads, ${csv.failedCount} failed uploads`,
		});
	}

	return (
		<Button
			disabled={fetchingRetryAll}
			onClick={retryFailed}
			className={`border-primarybuttonbg w-32 h-10 bg-tertiarybuttonbg border font-semibold text-primarybuttonbg tracking-wider ${className}`}
		>
			{fetchingRetryAll ? <Spinner width={15} /> : "Retry failed"}
		</Button>
	);
};
